if(!customElements.get('event-builder')) {
    class EventBuilder extends HTMLElement {
      constructor() {
        super();
        this.builder = this.closest('product-main-builder');
        this.datePicker = this.querySelector('[type="date"]');
        this.eventDatePicker = this.querySelector('.event-picker[type="date"]');
        this.eventTypeSelector = this.querySelector('select');
        this.eventData = JSON.parse(this.querySelector('[type="application/json"][data-event-builder-json]').textContent);
        this.monthlyTurnaroundsMap = this.eventData.monthly_turnarounds;
        if(this.eventData.blooms_box_availability_messages){
          this.bloomsBoxAvailabilityMap = this.eventData.blooms_box_availability_messages.map((item)=>{
            const splited = item.split(':');
            return {
              days: parseInt(splited[0]),
              message: splited[1],
              title: splited[2]
            }
          });
        }
        this.bloomsBoxAvailabilityDays = this.eventData.blooms_box_availability;
        this.messageTurnaround = this.querySelector('.message-turnaround')
        this.messageBlooms = this.querySelector('.message-blooms') || document.querySelector('.custom-card-event .message-blooms');
        this.messageInput = this.querySelector('.turnaround-estimate');
        this.bloomsSelector = this.querySelectorAll('[name="bloom_box"]');
        this.bloomProductInputs = this.querySelectorAll('.bloom-product input[type="hidden"]');
        this.bloomsBoxAvailable = false;
        this.openBloomBoxLearnMore = this.querySelector('.open-bloom-box-popup');
        this.preventBuy = this.dataset.preventBuy=='true';
        this.addToCartButton = this.closest('.product-main-element')?.querySelector('.btn.add');

        if(this.addToCartButton && this.preventBuy){
          this.addToCartButton.setAttribute('disabled', 'disabled');
        }

        if(this.openBloomBoxLearnMore){
          this.openBloomBoxLearnMore.addEventListener('click', (e)=>{
            const href = new URL(e.target.href);

            if(href.hash){
              e.preventDefault();
              const popup = document.querySelector(href.hash);
              
              if(popup){
                let popupSectionClone = popup.closest('.shopify-section').cloneNode(true);
                popupSectionClone.insertAdjacentHTML('beforeend', popup.innerHTML);
                $s.openModal(popupSectionClone, 'product-quick-view');
                $s.globalEval(popupSectionClone);
              }
            }
          })
        }

        if (this.eventDatePicker) {
          this.eventDatePicker.addEventListener('change', this.onEventDateChange.bind(this));
          const today = new Date().toISOString().split('T')[0];
          this.eventDatePicker.value = today;
          this.eventDatePicker.dispatchEvent(new Event('change'));
          this.querySelector('.custom-date-icon').addEventListener('click', () => {
            this.eventDatePicker.showPicker(); // Opens the native date picker
          });
        } else {
          this.datePicker.addEventListener('change', this.onDateChange.bind(this));
        }

        if(this.eventTypeSelector) {
            this.eventTypeSelector.addEventListener('change', this.onEventTypeChange.bind(this));
        }
  
        if(this.bloomsSelector.length > 0) {
          this.bloomsSelector.forEach((selector)=>{
            selector.addEventListener('change', this.onBloomsSelectorChange.bind(this));
          });
        }
  
      }
  
      onEventTypeChange() {
        if(this.eventTypeSelector.value == '') {
          this.eventTypeSelector.removeAttribute('name');
          return;
        }
        this.eventTypeSelector.setAttribute('name', this.eventTypeSelector.dataset.name);

        if(!this.builder) return;
        this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {eventType: this.eventTypeSelector.value}}));
      }
      onDateChange() {
        const currentHour = new Date().getHours();
        const date = new Date(this.datePicker.value + 'T' + (currentHour < 12 ? '12:00:00' : '23:59:59'));
        const productBloomBoxCheckbox = this.querySelector('[name="bloom_box"][data-product="true"]') || document.querySelector('.custom-card-event[name="bloom_box"][data-product="true"]');
  
        if(this.bloomsSelector) {
          this.bloomsSelector.forEach((selector)=>{
            selector.checked = false;
          });
        }

        if(this.bloomProductInputs) {
          this.bloomProductInputs.forEach((input)=>{
            input.removeAttribute('name');
          });
        }

        if(this.messageTurnaround) this.handleTournAroundMessage(date);
       
        if(this.bloomsBoxAvailabilityDays && this.daysUntil(date) >= this.bloomsBoxAvailabilityDays) {
          if (productBloomBoxCheckbox) {
            productBloomBoxCheckbox.removeAttribute('disabled');
            productBloomBoxCheckbox.closest('.swatch-group').classList.remove('hide');
          }
          this.bloomsBoxAvailable = true;
        } else {
          if (productBloomBoxCheckbox) {
            productBloomBoxCheckbox.setAttribute('disabled', 'disabled');
            productBloomBoxCheckbox.closest('.swatch-group').classList.add('hide');
          }
          this.bloomsBoxAvailable = false;
        }

        if(this.messageBlooms) this.handleBloomsBoxMessage(date);

        if(this.preventBuy){
          if(this.bloomsBoxAvailable){
            this.addToCartButton.removeAttribute('disabled');
          } else {
            this.addToCartButton.setAttribute('disabled', 'disabled');
          }
        }

        if(!this.builder) return;
        this.builder.dispatchEvent(new CustomEvent('stepChange', {detail: {}}));
      }

      onEventDateChange() {
        const currentHour = new Date().getHours();
        const date = new Date(this.datePicker.value + 'T' + (currentHour < 12 ? '12:00:00' : '23:59:59'));
        
        if(document.querySelector(".custom-card-event .event-message")) this.handleEventBloomsBoxMessage(date);

      }
  
      onBloomsSelectorChange(e) {
        this.handleProductInputs(e.target);
        if(!this.builder) return;
        this.builder.dispatchEvent(new CustomEvent('bundleChange', {detail: {}}));
      }

      handleProductInputs(input){
        if(input.checked) {
          this.bloomProductInputs.forEach((input)=>{
            input.setAttribute('name', input.dataset.name);
          });
          return;
        }
        
        this.bloomProductInputs.forEach((input)=>{
          input.removeAttribute('name');
        });
      }
  
      handleTournAroundMessage(date) {
        const monthIndex = date.getMonth();
        const monthTurnarounds = this.monthlyTurnaroundsMap[monthIndex];
  
        if (monthTurnarounds) {
            const message = lngg.product_main__builder__builder_event_message + ' ' + monthTurnarounds;
            this.messageTurnaround.innerHTML = message;
            this.messageInput.value = message;
            this.messageTurnaround.style.display = 'block';
            return;
        }
  
        this.messageTurnaround.style.display = 'none';
      }
  
      handleBloomsBoxMessage(selectedDate) {
        
        let selectedMessage = null;
        const diffDays = this.daysUntil(selectedDate);        
        if(selectedDate.toString() == 'Invalid Date') selectedMessage = lngg.product_main__builder__builder_shipping_empty_message;

        if(this.querySelector('.shipping-bloom')) this.querySelector('.shipping-bloom').innerHTML = '';

        if(this.eventData.blooms_box_available_message && this.eventData.blooms_box_unavailable_message){
          selectedMessage = this.eventData.based_on_text;
          selectedMessage += (this.bloomsBoxAvailable) ? this.eventData.blooms_box_available_message : this.eventData.blooms_box_unavailable_message;
          if(this.bloomsBoxAvailable && this.querySelector('.shipping-bloom')) this.querySelector('.shipping-bloom').innerHTML = this.eventData.blooms_box_unavailable_message;
        }

        if(this.eventData.blooms_box_unavailable_recreation_message && diffDays <= -5){
          selectedMessage = this.eventData.blooms_box_unavailable_recreation_message;
        }

        if (selectedMessage) {
          this.messageBlooms.innerHTML = selectedMessage;
          this.messageBlooms.style.display = 'block';

          this.querySelectorAll('a')?.forEach((link)=>{
            link.addEventListener('click', (e)=>{
              const href = new URL(e.target.href);
              if(href.hash){
                e.preventDefault();
                if(href.hash == '#open-info-modal'){
                  if(this.querySelector('#shipping-instructions-modal')) {
                    const shippingModal = this.querySelector('#shipping-instructions-modal').innerHTML;
                    $s.openModal(shippingModal, 'event-modal');
                    return;
                  }
                  const stepNumber = e.target.closest('.step').dataset.step/1;
                  const stepInfo = this.builder.stepsInfoData.find(step => step.step_number == stepNumber);
    
                  this.builder.openInfoModal(stepInfo.step_number);
                }
              }
            })
          })
          return;
        }
        
        this.messageBlooms.style.display = 'none';

      }

      handleEventBloomsBoxMessage(selectedDate) {
        const diffDays = this.daysUntil(selectedDate);
        const messages = this.bloomsBoxAvailabilityMap;

        this.bloomsBoxAvailabilityMap.sort((a, b) => a.days - b.days);
        let selectedMessage = null;
  
        for (let i = 0; i < messages.length; i++) {
          if (diffDays >= messages[i].days) {
            selectedMessage = messages[i];
          } else {
            break;
          }
        }

        if (selectedMessage) {
          document.querySelector(".custom-card-event").style.display = "block";
          document.querySelector(".custom-card-event .event-title").innerHTML = selectedMessage.title;
          document.querySelector(".custom-card-event .event-message").innerHTML = selectedMessage.message;
          if(selectedMessage.days >= 2){
            document.querySelector(".custom-card-event .bloom-box-link").style.display = "block";
          } else {
            document.querySelector(".custom-card-event .bloom-box-link").style.display = "none";
          }
          return;
        }
  
      }
  
      daysUntil(targetDate) {
        const target = new Date(targetDate);
        const now = new Date();
  
        target.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
  
        const differenceInMs = target - now;
        const daysDifference = differenceInMs / (1000 * 60 * 60 * 24);
  
        return Math.abs(daysDifference) < 1e-6 ? 0 : daysDifference;
      }
  
    }
    customElements.define('event-builder', EventBuilder);
  }